import React from "react";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { LookupOrderItem } from "../../../content-ingestion/common/lookup-order/LookupOrderItem";
import { LookupOrdersModal } from "../../../content-ingestion/common/lookup-order/LookupOrdersModal";

export type LookupOrdersButtonProps = {
    setContentFromLookupOrders: (item: LookupOrderItem) => void;
};

export const LookupOrdersButton = ({ setContentFromLookupOrders }: LookupOrdersButtonProps): JSX.Element => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    const onClick = (item: LookupOrderItem) => {
        setContentFromLookupOrders(item);
        onClose();
    };

    return (
        <>
            <CommandBarButton onClick={onOpen} text="Lookup orders" testId="content-lookup-orders" />
            <LookupOrdersModal isOpen={isOpen} onClose={onClose} onClick={onClick} />
        </>
    );
};
